/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Info/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import No from './No/index'
import React from 'react'
import Relative from './Relative/index'
import Total from './Total/index'



/** @type {import('Simple/types.js').View} */
export default function Info({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/TreatmentRequestOverride/Content/CustomPlan/MaxLength/Info"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let rulesetCustomPaymentPlanRulesetMaxLengthTypeValueData = fromData.useDataValue({ viewPath,
context: 'ruleset',
path: 'custom_payment_plan_ruleset.max_length_type',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: rulesetCustomPaymentPlanRulesetMaxLengthTypeValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Total'}>
<Total
  viewPath={`${viewPath}/Total`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Relative'}>
<Relative
  viewPath={`${viewPath}/Relative`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}